import { render, staticRenderFns } from "./RegimenFiscal.vue?vue&type=template&id=ade99232&scoped=true"
import script from "./RegimenFiscal.vue?vue&type=script&lang=js"
export * from "./RegimenFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade99232",
  null
  
)

export default component.exports